import type { ReactNode } from 'react';

interface SwitchProps {
  checked: boolean;
  onChange: () => void;
  ariaLabel?: string;
  /** 377: shown but not changeable (read-only for this viewer). */
  disabled?: boolean;
  // 110 follow-up: rendered inside the thumb itself, not beside the track.
  icon?: ReactNode;
}

/**
 * Pill switch (110). Track stays bg-canvas in both states — only the border
 * and thumb color change — matching the supplied reference exactly, using
 * only existing tokens (no new color value).
 */
export function Switch({ checked, onChange, ariaLabel, disabled, icon }: SwitchProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={ariaLabel}
      disabled={disabled}
      onClick={onChange}
      className={[
        'relative inline-flex h-6 w-11 shrink-0 items-center rounded-full border-2 bg-canvas transition-colors disabled:cursor-not-allowed disabled:opacity-60',
        checked ? 'border-primary' : 'border-hairline-strong',
      ].join(' ')}
    >
      <span
        aria-hidden="true"
        className={[
          'inline-flex h-4 w-4 items-center justify-center rounded-full transition-transform',
          checked
            ? 'translate-x-5 bg-primary text-on-primary'
            : 'translate-x-0.5 bg-hairline-strong text-ink',
        ].join(' ')}
      >
        {icon}
      </span>
    </button>
  );
}
